import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#337ab7',
          secondary: '#b0bec5',
          accent: '#0b5394',
          error: '#b71c1c',
        },
      },
    },
  });


